<template>
    <div>
        <a class="btn-annotation btn-play-karaoke"
           :class="`btn-play-karaoke-${props.annot.id}`"
           href="#"
           :style="data.styleRect"
           @click.prevent="playKaraokeParagraph"
        >
            <img :src="`${bookInfoState.publicPath}/${props.annot.iconSrc}`"
                 v-if="props.annot.iconSrc"
            >
        </a>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {useKaraokeControl} from "@/modules/reader/karaoke/karaokeControl";
    import {usePlayBlockControl} from "@/modules/reader/karaoke/playBlockControl";
    //import {replaceAudioPathForStagingServer} from  "@/modules/utils/pathUtils";
    import cssvar from '@/scss/_variables.scss';

    const colorRect = cssvar.colorRect;
    const {getResizedAnnotationPos, styleAnnotationBtn} = useAnnotationHelper();

    export default {

        props: {
          annot:Object,
          sharedMeta:Object,
          pagenum:Number
        },
        setup(props, context) {

            const { parserState, readData} = useParser();
            const { bookInfoState} = useBookInfo();
            const { pageResizeState} = usePageResize();
            const { karaokeState, setCurrentAudioSrc, stopAnimation, playParagraph} = useKaraokeControl();

            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos),
                        ...styleAnnotationBtn(props.annot.hide)
                    }
                }),
                /*
                wordAudioData:computed(()=>{
                    return props.sharedMeta[props.annot.grouptag]["wordAudioData"][bookInfoState.activeSpeech];
                })*/
            });

            const playKaraokeParagraph = (e)=> {

                //if there is parameter, it should be triggered by the singe play karaoke button. Reset karaoke data in this case:
                if (e && e.currentTarget) {
                    useKaraokeControl().reset();
                    usePlayBlockControl().reset();
                }

                //if there is btnIdPageMapping property, another paragraph will play after the current audio has finished playing.
                //It should be in Multiple page by paragraph mode. Please note that there are cases that both multi-whole-page and mulit-page paragraphs
                //can exist at the same time, so we have to confirm it's multi-page paragraphs if multi-whole-page is not playing
                let btnIdPageMapping = props.annot.btnIdPageMapping;

                if (btnIdPageMapping && !karaokeState.multiWholePageStatus.multiPageTargetBtnId) {
                    karaokeState.btnIdPageMapping = btnIdPageMapping;
                    karaokeState.playMode = useKaraokeControl().MODE_MULTIPLE_PAGE_PARA;
                } else if (karaokeState.multiWholePageStatus.multiPageTargetBtnId) {
                    karaokeState.playMode = useKaraokeControl().MODE_MULTIPLE_WHOLE_PAGE;
                //otherwise, it should be normal play karaoke mode, without multiple pages:
                } else {
                    stopAnimation();
                    karaokeState.playMode = useKaraokeControl().MODE_SINGLE_PARAGRAPH;
                }

                karaokeState.currentAudioId = props.annot.audioId;
                karaokeState.activeGrouptag = props.annot.grouptag;
                karaokeState.activeAudioSrc = setCurrentAudioSrc(props.annot.audioSrc);
                //if served on staging (.23), update url to make 206 response available...
                //karaokeState.activeAudioSrc  = replaceAudioPathForStagingServer(karaokeState.activeAudioSrc);
                karaokeState.activeAudioSrc = karaokeState.activeAudioSrc;
                karaokeState.activePageNum = props.pagenum;
                karaokeState.btnId = props.annot.id;

                let wordAudioData = props.sharedMeta[props.annot.grouptag]["wordAudioData"][bookInfoState.activeSpeech];

                //nextTick is required here since we need wait for the audio player to be available to play after currentAudioId is set
                nextTick(()=>{
                    playParagraph(wordAudioData);
                })
            }

            watchEffect(()=>{


                if (karaokeState.multiWholePageStatus.multiPageTargetBtnId === props.annot.id &&
                    karaokeState.multiWholePageStatus.multiPageTargetPageNum === props.pagenum) {
                    console.log("multi whole page karaoke target retrieved! @PlayKaraokeBtn.vue");
                    playKaraokeParagraph();
                }

                if (karaokeState.multiplePageParaStatus.aimPageBtnId === props.annot.id &&
                    karaokeState.multiplePageParaStatus.aimPageIndex === props.pagenum) {
                    console.log("multiple by para target retrieved! @PlayKaraokeBtn.vue");
                    playKaraokeParagraph();
                }


            })

            return {
                props,
                data,
                pageResizeState,
                bookInfoState,
                parserState,
                karaokeState,
                stopAnimation,
                playKaraokeParagraph,
                playParagraph,
                setCurrentAudioSrc,
                getResizedAnnotationPos
            }

        }
    }

 </script>


<style scoped lang="scss">


</style>